/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESSubmittedApplications.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_ACES_SUBMITTED_APPLICATIONS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESSUBMITTEDAPPLICATIONS/FETCH_ACES_SUBMITTED_APPLICATIONS`
);

export { FETCH_ACES_SUBMITTED_APPLICATIONS };
